import type { FlowTemplateSchema } from "@/app/_api/flowTemplatesServer";
import { appUrls } from "@/constants";

/**
 * The xi web-app deep link to a flow template's run page. Shared by the static
 * "try this template" CTA (server-rendered hero/remind links) and the post-run
 * redirect/claim builders (client). Kept free of client-only imports — it only
 * needs `appUrls` — so server code can build it too.
 */
export function buildFlowTemplateBaseUrl(flowTemplate: Pick<FlowTemplateSchema, "id">) {
  return new URL(`/app/templates/${encodeURIComponent(flowTemplate.id)}`, appUrls.root);
}
